import {
  SignInPage,
  SignUpPage,
  ResetPasswordPage,
  UserProfile,
  ShipmentTrackingPage,
  Vehicles
} from './pages';
import { withNavigationWatcher } from './contexts/navigation';
import RoutesPageNew from './pages/mapping/RoutesPage/RoutesPage';
import Customers from './pages/mapping/Customer/Customers';
import { ThemeList } from './pages/manegement/themeSetting/themeList';

const routes = [
  {
    path: '/sign-in-form',
    element: SignInPage,
  },
  {
    path: '/sign-up-form',
    element: SignUpPage,
  },
  {
    path: '/reset-password-form',
    element: ResetPasswordPage,
  },
  {
    path: '/user-profile',
    element: UserProfile,
  },
  
  {
    path: '/vehicles',
    element: Vehicles,
  },
    {
    path: '/routes',
    element: RoutesPageNew,
  },
  {
    path: '/customer',
    element: Customers,
  },{
    path: '/theme',
    element: ThemeList,
  }

  

];

export const appRoutes = routes.map((route) => {
  return {
    ...route,
    element: withNavigationWatcher(route.element, route.path),
  };
});
